
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052B4","d":"M0 0h512v341.3H0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M0 233.5h512v51H0z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M168.7 86.5l12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zM85.4 32.5l7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z"}})])])
          )
        }
      }
    